const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '查看异议',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '异议答复',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]
// const { getProjectTypeName } = require('../projectType')
const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
            typeTitle: this.$store.state.logoType === 1 ? '澄清' : '质疑',
        }
    },
    computed: {
        waitsData() {
            return this.$store.state.bids.waitIdsInfo
        },
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/dycq/problemDetail.do`, { bdGuid: this.waitsData.bdGuid }).then((res) => {
                this.config[1].options.data = {
                    '标段名称': res.data.ggName,
                    '标段编号': res.data.projectName,
                    '发起单位': res.data.bdName,
                    '联系人': res.data.bdBH,
                    '联系电话': res.data.bgTitle,
                    '异议阶段': this.typeTitle + res.data.bgTypeC,
                    '异议发起时间': this.typeTitle + this.$util.timeFormatter(res.data.bgTypeC),
                    '异议截止时间': this.typeTitle + this.$util.timeFormatter(res.data.bgTypeC),
                    '异议标题': res.data.bgTypeC,
                    '答复状态': res.data.bgTypeC,
                    '异议内容': this.typeTitle + res.data.bgTypeC,
                }
                this.config[3].options.data = {
                    '异议答复标题': res.data.dycqTitle,
                    '异议答复内容': res.data.dycqTitle,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
